'use client';

import { useAtomValue } from 'jotai/react';
import { sidebarAtom } from 'src/services/state/atoms/sidebar';

import { useTranslations } from 'next-intl';

import Breadcrumbs from './Breadcrumbs';
import FlashMessage from './FlashMessage/FlashMessage';
import Footer from './Footer';
import Header from './Header';
import RedirectGuard from './RedirectGuard';
import { SessionTimeoutOverlay } from './SessionTimeoutOverlay';
import Sidebar from './Sidebar';
import SupportSection from './SupportSection';

type Props = {
  children: React.ReactNode;
};

const Layout = ({ children }: Props) => {
  const t = useTranslations('components.Layout');
  const { visible } = useAtomValue(sidebarAtom);

  return (
    <div className="display-flex flex-column minh-viewport">
      <SessionTimeoutOverlay />
      <a className="usa-skipnav" href="#main-content">
        {t('skip_to_main')}
      </a>
      <Header />
      {/* grid-col-fill so that the footer sticks to the bottom of tall screens */}
      <main id="main-content" className="grid-col-fill grid-container page-content">
        <Sidebar />
        {visible && <div className="content-overlay"></div>}
        <Breadcrumbs />
        <FlashMessage />
        <RedirectGuard>{children}</RedirectGuard>
        <SupportSection />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
